var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAIres11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52,54H18c-1.654,0-3-1.346-3-3V15c0-1.654,1.346-3,3-3h34c1.654,0,3,1.346,3,3v36    C55,52.654,53.654,54,52,54z M18,14c-0.551,0-1,0.448-1,1v36c0,0.552,0.449,1,1,1h34c0.551,0,1-0.448,1-1V15c0-0.552-0.449-1-1-1    H18z",
    style: {
      fill: "#E56565"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51,50H19V16h32V50z M21,48h28V18H21V48z",
    style: {
      fill: "#E56565"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42,28c0-3.906-3.198-7.064-7.119-6.999c-3.654,0.061-6.745,3.089-6.877,6.741    c-0.064,1.785,0.541,3.424,1.584,4.691C31.064,34.226,32,36.399,32,38.721V41h6v-1.943c0-2.477,0.979-4.799,2.51-6.747    C41.443,31.124,42,29.628,42,28z",
    style: {
      fill: "#FFCB57"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.005,27.706c-0.07,1.953,0.573,3.857,1.812,5.363C30.245,34.804,31,36.758,31,38.721V42h8    v-2.942c0-2.1,0.794-4.219,2.296-6.129C42.411,31.511,43,29.807,43,28c0-2.162-0.849-4.188-2.39-5.703    c-1.541-1.516-3.572-2.348-5.745-2.296C30.682,20.07,27.156,23.527,27.005,27.706z M37,40h-4v-1h4.003    c0,0.019-0.003,0.038-0.003,0.058V40z M34.898,22.001c1.621-0.045,3.154,0.585,4.31,1.722S41,26.379,41,28    c0,1.354-0.441,2.631-1.276,3.692c-1.301,1.655-2.149,3.46-2.515,5.308H36v-5h-2v5h-1.157c-0.326-1.83-1.166-3.603-2.483-5.202    c-0.928-1.127-1.41-2.555-1.356-4.02C29.117,24.645,31.761,22.053,34.898,22.001z",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,43h-2c0,0.552-0.449,1-1,1s-1-0.448-1-1h-2c0,1.654,1.346,3,3,3S38,44.654,38,43z",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3F3A34"
    },
    width: 2,
    x: 34,
    y: 28
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8,31 13,31 13,29 10,29 10,23 13,23 13,21 8,21   ",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8,44 13,44 13,42 10,42 10,36 13,36 13,34 8,34   ",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19,1 19,10 21,10 21,3 49,3 49,10 51,10 51,1   ",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3F3A34"
    },
    width: 2,
    x: 34,
    y: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49,61 21,61 21,56 19,56 19,63 51,63 51,56 49,56   ",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3F3A34"
    },
    width: 2,
    x: 34,
    y: 57
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIres11);
export default __webpack_public_path__ + "static/media/AIres11.f7d24eec45cf068fe298f24fca92692b.svg";
export { ForwardRef as ReactComponent };